import React, { Component } from 'react'
import Fade from 'react-reveal/Fade'

class JournalFilter extends Component {

  state = {
    dropdown: false,
    filterCategories: [],
  }

  handleCategoryClick = (item) => {
    let array = [...this.state.filterCategories]
    let index = array.indexOf(item)
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ filterCategories: array, dropdown: false }, this.updateList);
    } else {
      this.setState(prevState => ({
        filterCategories: [item], dropdown: false
      }), this.updateList)
    }
  }

  updateList = () => {
    const { list, set } = this.props
    const { filterCategories } = this.state

    let results = {}

    if (list) {
      results = list?.filter((el, i) => {
        if ( filterCategories?.length > 0 ) {
          return el.categories.nodes.find((el) => filterCategories.includes(el.name))
        }
        return true
      })
    }
    set(results)
  }

  render() {
    let { filterCategories, dropdown } = this.state
    let { title, categories } = this.props

    const buttonProps = {
      type: 'button',
      onMouseEnter: () => window?._handleMouseEnter(''),
      onMouseLeave: () => window?._handleMouseLeave(),
    }
    
    return (
      <section className='filter filter--journal'>
        <div className={`filter__dropdown active`}>
          <div className='filter__inner'>
            
            <div className='filter__items'>
              <div className='filter__item'>
                <ul>
                  { categories?.nodes?.map((el, i) => (
                    <li key={i}>
                      <button
                        className={filterCategories?.includes(el.name) ? 'active' : ''} 
                        onClick={() => this.handleCategoryClick(el.name)}
                        {...buttonProps}>
                        {el.name}
                      </button>
                    </li>
                  )) }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

JournalFilter.defaultProps = {
  title: 'Journal',
  list: [],
  set: () => {},
  categories: [],
}

export default JournalFilter